import xlsx from 'xlsx';
import moment from 'moment';

export default {
  methods: {
    generarExcelInfoCobranzas(todosLosDatos) {
      console.log(
        '📊 Excel Export Info Cobranzas - Registros:',
        todosLosDatos.length
      );

      if (!todosLosDatos || todosLosDatos.length === 0) {
        console.warn('No hay datos para exportar');
        return;
      }

      // Filtrar filas de encabezado de fideicomiso y extraer fideicomisos únicos
      const datosSinHeadersFideicomiso = todosLosDatos.filter(item => !item._esFideicomisoHeader);
      const fideicomisosUnicos = [...new Set(
        datosSinHeadersFideicomiso
          .filter(item => !item._esSubtotal && item.fideicomiso)
          .map(item => item.fideicomiso)
      )];

      let periodosOrdenados = [];

      if (this.esOperacion === 'Info Cobranzas Proyectadas') {
        // Para Info Cobranzas Proyectadas, detectar propiedades fecha_MES_AÑO
        const periodosUnicos = new Set();

        // Detectar desde las propiedades procesadas fecha_MES_AÑO
        datosSinHeadersFideicomiso.forEach((item) => {
          if (!item._esSubtotal) {
            // Buscar todas las propiedades que empiecen con "fecha_" y terminen con "_YYYY"
            Object.keys(item).forEach(key => {
              if (key.startsWith('fecha_') && item[key] && item[key] > 0) {
                // Extraer mes y año del formato fecha_MES_AÑO
                const partes = key.split('_');
                if (partes.length === 3) {
                  const mes = parseInt(partes[1], 10);
                  const año = parseInt(partes[2], 10);

                  if (mes >= 1 && mes <= 12 && año > 2000) {
                    const periodo = `${año}-${mes.toString().padStart(2, '0')}`;
                    periodosUnicos.add(periodo);
                  }
                }
              }
            });
          }
        });

        // También buscar en subtotales como confirmación
        datosSinHeadersFideicomiso.forEach((item) => {
          if (item._esSubtotal && item.subtotales && Array.isArray(item.subtotales)) {
            item.subtotales.forEach(sub => {
              if (sub.mesAño) {
                // El mesAño viene como "MM-YYYY", convertir a "YYYY-MM"
                const [mesStr, añoStr] = sub.mesAño.split('-');
                const periodo = `${añoStr}-${mesStr}`;
                periodosUnicos.add(periodo);
              }
            });
          }
        });

        // Ordenar cronológicamente
        periodosOrdenados = Array.from(periodosUnicos).sort();
      } else {
        // Para Info Cobranzas normal, detectar propiedades periodo_YYYY-MM
        const periodosUnicos = new Set();
        datosSinHeadersFideicomiso.forEach((item) => {
          if (!item._esSubtotal) {
            // Buscar todas las propiedades que empiecen con "periodo_"
            Object.keys(item).forEach(key => {
              if (key.startsWith('periodo_') && item[key] && item[key] > 0) {
                // Extraer el período YYYY-MM de la clave periodo_YYYY-MM
                const periodo = key.replace('periodo_', '');
                periodosUnicos.add(periodo);
              }
            });
          }
        });
        periodosOrdenados = Array.from(periodosUnicos).sort();
      }

      console.log('📅 Períodos encontrados:', periodosOrdenados);

      // Debug: Comparar estructuras según el tipo de operación
      console.log(`🔍 ANÁLISIS DE DATOS - Operación: ${this.esOperacion}`);
      console.log('📊 Primer registro regular:', todosLosDatos.find(item => !item._esSubtotal));
      console.log('📊 Primer subtotal:', todosLosDatos.find(item => item._esSubtotal));



      // Preparar datos para Excel
      const excelData = [];

      // Agregar título
      const tituloReporte =
        this.esOperacion === 'Info Cobranzas'
          ? 'INFO COBRANZAS'
          : 'INFO COBRANZAS PROYECTADAS';
      const titleRow = Array(8 + periodosOrdenados.length).fill('');
      titleRow[0] = tituloReporte;
      excelData.push(titleRow);

      // Agregar fila de fideicomisos
      if (fideicomisosUnicos.length > 0) {
        const fideicomisoRow = Array(8 + periodosOrdenados.length).fill('');
        fideicomisoRow[0] = `Fideicomiso${fideicomisosUnicos.length > 1 ? 's' : ''}: ${fideicomisosUnicos.join(', ')}`;
        excelData.push(fideicomisoRow);
      }

      // Agregar fecha de consulta
      const consultaRow = Array(8 + periodosOrdenados.length).fill('');
      consultaRow[0] = `Fecha de consulta: ${this.fechaInicio || 'N/A'} - ${
        this.fechaFinal || 'N/A'
      }`;
      excelData.push(consultaRow);

      // Agregar fecha de generación
      const dateRow = Array(8 + periodosOrdenados.length).fill('');
      dateRow[0] = `Generado el: ${moment().format('DD/MM/YYYY HH:mm')}`;
      excelData.push(dateRow);

      // Agregar fila vacía
      excelData.push(Array(8 + periodosOrdenados.length).fill(''));

      // Preparar headers
      const baseHeaders = [
        'Legajo',
        'Operatoria/Línea',
        'Nombre/Razón Social',
        'CUIT',
        'Persona',
        'Fecha Ingreso',
        'Estado',
        'Total del Período',
      ];

      // Agregar headers de períodos
      const periodosHeaders = periodosOrdenados.map((periodo) =>
        this.formatearPeriodoHeader(periodo)
      );
      const allHeaders = [...baseHeaders, ...periodosHeaders];
      excelData.push(allHeaders);

      // Procesar datos
      datosSinHeadersFideicomiso.forEach((item) => {
        const row = [];

        if (item._esSubtotal) {
          // Fila de subtotal
          row.push('SUBTOTAL'); // Legajo
          row.push(item.operatoria_linea.replace('Subtotal ', '')); // Operatoria
          row.push(''); // Nombre
          row.push(''); // CUIT
          row.push(''); // Persona
          row.push(''); // Fecha Ingreso
          row.push(''); // Estado
          row.push(this.getSubtotalPeriodo(item)); // Total del Período

          // Agregar totales por período
          periodosOrdenados.forEach((periodo) => {
            let totalPeriodo = 0;
            if (this.esOperacion === 'Info Cobranzas Proyectadas') {
              // Extraer el mes y año del período YYYY-MM
              const [year, month] = periodo.split('-');
              const mesNum = parseInt(month, 10);
              const añoNum = parseInt(year, 10);
              totalPeriodo = this.getSubtotalParaMes(item, mesNum, añoNum);
            } else {
              totalPeriodo = this.getTotalSubtotalPorPeriodo(item, periodo);
            }
            row.push(totalPeriodo);
          });
        } else {
          // Fila normal
          row.push(item.legajo || ''); // Legajo
          row.push(item.operatoria_linea || ''); // Operatoria
          row.push(item.nombre_razon_social.toUpperCase() || ''); // Nombre
          row.push(item.cuit || ''); // CUIT
          row.push(item.persona || ''); // Persona
          row.push(this.formatearFechaExcel(item.fecha_ingreso)); // Fecha Ingreso
          row.push(item.estado || ''); // Estado
          row.push(parseFloat(item.periodo) || 0); // Total del Período

          // Agregar montos por período
          periodosOrdenados.forEach((periodo) => {
            let monto = 0;
            if (this.esOperacion === 'Info Cobranzas Proyectadas') {
              // Para Info Cobranzas Proyectadas usar el método específico
              monto = this.getMontoPorPeriodoProyectada(item, periodo);
            } else {
              monto = this.getMontoPorPeriodo(item, periodo);
            }
            row.push(monto);
          });
        }

        excelData.push(row);
      });

      // Calcular totales generales (excluyendo subtotales)
      const datosRegulares = datosSinHeadersFideicomiso.filter((item) => !item._esSubtotal);

      // Fila de totales generales
      const totalRow = [];
      totalRow.push('TOTAL GENERAL'); // Legajo
      totalRow.push(''); // Operatoria
      totalRow.push(''); // Nombre
      totalRow.push(''); // CUIT
      totalRow.push(''); // Persona
      totalRow.push(''); // Fecha Ingreso
      totalRow.push(''); // Estado

      // Total del período
      const totalPeriodo = datosRegulares.reduce((total, item) => {
        return total + (parseFloat(item.periodo) || 0);
      }, 0);
      totalRow.push(totalPeriodo);

      // Totales por período
      periodosOrdenados.forEach((periodo) => {
        let totalPeriodo = 0;
        if (this.esOperacion === 'Info Cobranzas Proyectadas') {
          // Para Info Cobranzas Proyectadas, sumar usando el método específico
          totalPeriodo = datosRegulares.reduce((total, item) => {
            const monto = this.getMontoPorPeriodoProyectada(item, periodo);
            return total + (monto || 0);
          }, 0);
        } else {
          totalPeriodo = this.getTotalPeriodoGeneral(datosRegulares, periodo);
        }
        totalRow.push(totalPeriodo);
      });

      excelData.push(totalRow);

      // Crear workbook y worksheet
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();

      // Configurar anchos de columna
      const colWidths = [
        { wch: 10 }, // Legajo
        { wch: 25 }, // Operatoria
        { wch: 35 }, // Nombre
        { wch: 15 }, // CUIT
        { wch: 12 }, // Persona
        { wch: 15 }, // Fecha Ingreso
        { wch: 15 }, // Estado
        { wch: 18 }, // Total Período
        ...periodosOrdenados.map(() => ({ wch: 15 })), // Columnas de períodos
      ];

      ws['!cols'] = colWidths;

      // Agregar formato a las celdas de montos (números)
      const range = xlsx.utils.decode_range(ws['!ref']);
      for (let R = 5; R <= range.e.r; R++) {
        // Desde la fila de datos
        // Columna Total del Período (índice 7)
        const totalPeriodoCell = xlsx.utils.encode_cell({ r: R, c: 7 });
        if (
          ws[totalPeriodoCell] &&
          typeof ws[totalPeriodoCell].v === 'number'
        ) {
          ws[totalPeriodoCell].t = 'n';
          ws[totalPeriodoCell].z = '#,##0.00';
        }

        // Columnas de períodos (desde índice 8)
        for (let C = 8; C < 8 + periodosOrdenados.length; C++) {
          const periodoCell = xlsx.utils.encode_cell({ r: R, c: C });
          if (ws[periodoCell] && typeof ws[periodoCell].v === 'number') {
            ws[periodoCell].t = 'n';
            ws[periodoCell].z = '#,##0.00';
          }
        }
      }

      // Agregar hoja al workbook
      xlsx.utils.book_append_sheet(wb, ws, tituloReporte);

      // Descargar el archivo
      const fileName =
        this.esOperacion === 'Info Cobranzas'
          ? `info-cobranzas-${moment().format('YYYY-MM-DD')}.xlsx`
          : `info-cobranzas-proyectadas-${moment().format('YYYY-MM-DD')}.xlsx`;

      xlsx.writeFile(wb, fileName);
    },

    // Métodos auxiliares para Info Cobranzas
    formatearPeriodoHeader(periodo) {
      if (!periodo) return '';
      const [year, month] = periodo.split('-');
      const meses = {
        '01': 'Ene',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Abr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Ago',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dic',
      };
      return `${meses[month] || month} ${year}`;
    },

    formatearFechaHeader(fecha) {
      // Mantener compatibilidad con Info Cobranzas Proyectadas
      return this.formatearPeriodoHeader(fecha);
    },

    formatearFechaExcel(fecha) {
      if (!fecha) return '';
      const momentDate = moment(fecha);
      if (momentDate.isValid()) {
        return momentDate.format('DD/MM/YYYY');
      }
      return fecha;
    },

    getMontoPorPeriodo(item, periodo) {
      // PRIORIDAD 1: Usar la propiedad procesada periodo_YYYY-MM
      const propertyKey = `periodo_${periodo}`;
      if (item[propertyKey] !== undefined) {
        return parseFloat(item[propertyKey]) || 0;
      }

      // FALLBACK: Buscar en cuotas_detalle (legacy)
      if (!item.cuotas_detalle || !Array.isArray(item.cuotas_detalle)) {
        return null;
      }

      // Para Info Cobranzas normal: buscar por fecimputa
      const cuota = item.cuotas_detalle.find(
        (c) => c.fecimputa === periodo
      );
      return cuota ? parseFloat(cuota.cobrado) : null;
    },

    // Método para Info Cobranzas Proyectadas: buscar por período en formato YYYY-MM
    getMontoPorPeriodoProyectada(item, periodo) {
      // Convertir período YYYY-MM a formato de propiedad procesada fecha_MES_AÑO
      const [year, month] = periodo.split('-');
      const mesNum = parseInt(month, 10);
      const añoNum = parseInt(year, 10);

      // PRIORIDAD 1: Usar la propiedad procesada fecha_MES_AÑO
      const propertyKey = `fecha_${mesNum}_${añoNum}`;
      if (item[propertyKey] !== undefined) {
        return parseFloat(item[propertyKey]) || 0;
      }

      // FALLBACK: Buscar en cuotas_detalle (legacy)
      if (!item.cuotas_detalle || !Array.isArray(item.cuotas_detalle)) {
        return 0;
      }

      // Buscar la cuota que corresponde al mes y año del período
      const cuota = item.cuotas_detalle.find(c => {
        if (!c.fechaVencimiento) return false;
        const fecha = new Date(c.fechaVencimiento);
        const mesVencimiento = fecha.getMonth() + 1;
        const añoVencimiento = fecha.getFullYear();
        return mesVencimiento === mesNum && añoVencimiento === añoNum;
      });

      return cuota ? parseFloat(cuota.montoCuota) || 0 : 0;
    },

    getCuotaPorFecha(item, fecha) {
      // Mantener compatibilidad con Info Cobranzas Proyectadas
      if (!item.cuotas_detalle || !Array.isArray(item.cuotas_detalle)) {
        return null;
      }

      const cuota = item.cuotas_detalle.find(
        (c) => c.fechaVencimiento === fecha
      );
      return cuota ? parseFloat(cuota.montoCuota) : null;
    },

    getTotalSubtotalPorPeriodo(item, periodo) {
      if (!item.subtotales || !Array.isArray(item.subtotales)) {
        return null;
      }

      const [year, month] = periodo.split('-');
      const mesAño = `${month}-${year}`;

      const subtotal = item.subtotales.find((s) => s.mesAño === mesAño);
      return subtotal ? parseFloat(subtotal.totalMes) : null;
    },

    getTotalSubtotal(item, fecha) {
      // Mantener compatibilidad con Info Cobranzas Proyectadas
      return this.getTotalSubtotalPorPeriodo(item, fecha);
    },

    getSubtotalPeriodo(item) {
      if (
        !item._esSubtotal ||
        !item.subtotales ||
        !Array.isArray(item.subtotales)
      ) {
        return 0;
      }

      return item.subtotales.reduce((total, subtotal) => {
        return total + (parseFloat(subtotal.totalMes) || 0);
      }, 0);
    },

    getContadorRegistrosOperatoria(operatoria, todosLosDatos = null) {
      const datos = todosLosDatos || this.resultados;
      if (!datos) return 0;
      return datos.filter(
        (item) => !item._esSubtotal && item.operatoria_linea === operatoria
      ).length;
    },

    getTotalPeriodoGeneral(datosRegulares, periodo) {
      return datosRegulares.reduce((total, item) => {
        const monto = this.getMontoPorPeriodo(item, periodo);
        return total + (monto || 0);
      }, 0);
    },

    getTotalFechaGeneral(datosRegulares, fecha) {
      // Mantener compatibilidad con Info Cobranzas Proyectadas
      return this.getTotalPeriodoGeneral(datosRegulares, fecha);
    },

    // Método específico para obtener el subtotal de un mes y año en Info Cobranzas Proyectadas
    getSubtotalParaMes(item, mes, año = null) {
      if (!item._esSubtotal || !item.subtotales) {
        return 0;
      }

      // Buscar en el array de subtotales el mes y año correspondiente
      const subtotal = item.subtotales.find(sub => {
        // El mesAño viene como "MM-YYYY", extraemos el mes y año
        const [mesStr, añoStr] = sub.mesAño.split('-');
        const mesNum = parseInt(mesStr, 10);
        const añoNum = parseInt(añoStr, 10);

        // Si se proporciona año, validar mes Y año. Si no, solo validar mes (backward compatibility)
        if (año !== null) {
          return mesNum === mes && añoNum === año;
        }
        return mesNum === mes;
      });

      return subtotal ? subtotal.totalMes : 0;
    },


    // Método específico para exportar Info Mora (Financiamiento)
    generarExcelInfoMora(todosLosDatos) {
      console.log(
        '📊 Excel Export Info Mora - Registros:',
        todosLosDatos.length
      );

      if (!todosLosDatos || todosLosDatos.length === 0) {
        console.warn('No hay datos para exportar');
        return;
      }

      // Filtrar filas de encabezado de fideicomiso y extraer fideicomisos únicos
      const datosSinHeadersFideicomiso = todosLosDatos.filter(item => !item._esFideicomisoHeader);
      const fideicomisosUnicos = [...new Set(
        datosSinHeadersFideicomiso
          .filter(item => item.fideicomiso)
          .map(item => item.fideicomiso)
      )];

      // Preparar datos para Excel
      const excelData = [];

      // Agregar título
      const titleRow = Array(21).fill(''); // 21 columnas para Info Mora (sin Fideicomiso)
      titleRow[0] = 'INFO MORA (FINANCIAMIENTO)';
      excelData.push(titleRow);

      // Agregar fila de fideicomisos
      if (fideicomisosUnicos.length > 0) {
        const fideicomisoRow = Array(21).fill('');
        fideicomisoRow[0] = `Fideicomiso${fideicomisosUnicos.length > 1 ? 's' : ''}: ${fideicomisosUnicos.join(', ')}`;
        excelData.push(fideicomisoRow);
      }

      // Agregar fecha de consulta
      const consultaRow = Array(21).fill('');
      consultaRow[0] = `Fecha de consulta: ${this.fechaInicio || 'N/A'} - ${
        this.fechaFinal || 'N/A'
      }`;
      excelData.push(consultaRow);

      // Agregar fecha de generación
      const dateRow = Array(21).fill('');
      dateRow[0] = `Generado el: ${moment().format('DD/MM/YYYY HH:mm')}`;
      excelData.push(dateRow);

      // Agregar fila vacía
      excelData.push(Array(21).fill(''));

      // Headers para Info Mora
      const allHeaders = [
        'Legajo',
        'Operatoria/Línea',
        'Nombre/Razón Social',
        'CUIT',
        'Persona',
        'Fecha Ingreso',
        'Estado',
        'Monto Otorgado',
        'Monto ANR',
        'Monto Crédito',
        'Fecha de Otorgamiento',
        'Cantidad Cuotas',
        'Saldo Capital',
        'Monto Cobrado',
        'Cuotas en Mora',
        'Monto Vencido',
        'Monto en Mora',
        'Días de Mora',
        'Estado Morosidad',
        'Porcentaje de Mora',
        'Estado Manual',
      ];

      excelData.push(allHeaders);

      // Procesar datos
      datosSinHeadersFideicomiso.forEach((item) => {
        const row = [];

        // Datos básicos
        row.push(item.legajo || ''); // Legajo
        row.push(item.operatoria_linea || ''); // Operatoria
        row.push(item.nombre_razon_social.toUpperCase() || ''); // Nombre
        row.push(item.cuit || ''); // CUIT
        row.push(item.persona || ''); // Persona
        row.push(this.formatearFechaExcel(item.fecha_ingreso)); // Fecha Ingreso
        row.push(item.estado || ''); // Estado
        row.push(parseFloat(item.monto) || 0); // Monto Otorgado
        row.push(parseFloat(item.monto_anr) || 0); // Monto ANR

        // Monto Crédito (calculado)
        const montoCredito =
          (parseFloat(item.monto) || 0) - (parseFloat(item.monto_anr) || 0);
        row.push(montoCredito); // Monto Crédito

        row.push(item.fecha_otorgamiento || ''); // Fecha de Otorgamiento
        row.push(item.cantidad_cuotas || ''); // Cantidad Cuotas
        row.push(parseFloat(item.saldo_capital) || 0); // Saldo Capital
        row.push(parseFloat(item.monto_cobrado) || 0); // Monto Cobrado
        row.push(item.cantidad_cuotas_mora || ''); // Cuotas en Mora
        row.push(parseFloat(item.capital_vencido) || 0); // Capital Vencido
        row.push(parseFloat(item.monto_mora) || 0); // Monto en Mora
        row.push(item.dias_mora || ''); // Días de Mora
        row.push(item.estado_morosidad || ''); // Estado Morosidad

        // Porcentaje de Mora (calculado y convertido a formato decimal de Excel)
        const porcentajeMora = this.calcularPorcentajeMoraExcel(
          item.monto_mora,
          item.capital_vencido
        );
        // Guardar como decimal (0.XX) para que Excel lo interprete como porcentaje
        row.push(porcentajeMora / 100); // Porcentaje de Mora como decimal

        row.push(item.estado_manual || ''); // Estado Manual

        excelData.push(row);
      });

      // Calcular totales (usando la misma lógica que la tabla)
      const totalRow = [];
      totalRow.push('TOTAL GENERAL'); // Legajo
      totalRow.push(''); // Operatoria
      totalRow.push(''); // Nombre
      totalRow.push(''); // CUIT
      totalRow.push(''); // Persona
      totalRow.push(''); // Fecha Ingreso
      totalRow.push(''); // Estado

      // Totales de montos
      const totalMonto = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.monto) || 0),
        0
      );
      totalRow.push(totalMonto); // Monto Otorgado

      const totalMontoAnr = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.monto_anr) || 0),
        0
      );
      totalRow.push(totalMontoAnr); // Monto ANR

      const totalMontoCredito = totalMonto - totalMontoAnr;
      totalRow.push(totalMontoCredito); // Monto Crédito

      totalRow.push(''); // Fecha de Otorgamiento
      totalRow.push(''); // Cantidad Cuotas

      const totalSaldoCapital = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.saldo_capital) || 0),
        0
      );
      totalRow.push(totalSaldoCapital); // Saldo Capital

      const totalMontoCobrado = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.monto_cobrado) || 0),
        0
      );
      totalRow.push(totalMontoCobrado); // Monto Cobrado

      totalRow.push(''); // Cuotas en Mora

      const totalCapitalVencido = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.capital_vencido) || 0),
        0
      );
      totalRow.push(totalCapitalVencido); // Capital Vencido

      const totalMontoMora = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.monto_mora) || 0),
        0
      );
      totalRow.push(totalMontoMora); // Monto en Mora

      // Promedio días de mora
      const sumaDiasMora = todosLosDatos.reduce(
        (total, item) => total + (parseFloat(item.dias_mora) || 0),
        0
      );
      const promedioDiasMora =
        todosLosDatos.length > 0 ? sumaDiasMora / todosLosDatos.length : 0;
      totalRow.push(`${Math.round(promedioDiasMora)} días-Promedio`); // Días de Mora

      totalRow.push(''); // Estado Morosidad
      totalRow.push(''); // Porcentaje de Mora
      totalRow.push(''); // Estado Manual

      excelData.push(totalRow);

      // Crear workbook y worksheet
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();

      // Configurar anchos de columna
      const colWidths = [
        { wch: 10 }, // Legajo
        { wch: 25 }, // Operatoria
        { wch: 35 }, // Nombre
        { wch: 15 }, // CUIT
        { wch: 12 }, // Persona
        { wch: 15 }, // Fecha Ingreso
        { wch: 15 }, // Estado
        { wch: 18 }, // Monto Otorgado
        { wch: 15 }, // Monto ANR
        { wch: 18 }, // Monto Crédito
        { wch: 18 }, // Fecha de Otorgamiento
        { wch: 15 }, // Cantidad Cuotas
        { wch: 18 }, // Saldo Capital
        { wch: 18 }, // Monto Cobrado
        { wch: 15 }, // Cuotas en Mora
        { wch: 18 }, // Capital Vencido
        { wch: 18 }, // Monto en Mora
        { wch: 15 }, // Días de Mora
        { wch: 18 }, // Estado Morosidad
        { wch: 18 }, // Porcentaje de Mora
        { wch: 15 }, // Estado Manual
      ];

      ws['!cols'] = colWidths;

      // Agregar formato a las celdas de montos (números)
      const range = xlsx.utils.decode_range(ws['!ref']);
      for (let R = 5; R <= range.e.r; R++) {
        // Desde la fila de datos
        // Formatear columnas de montos (índices ajustados sin columna Fideicomiso)
        const montoColumns = [7, 8, 9, 12, 13, 15, 16]; // Índices de columnas de montos
        montoColumns.forEach((colIndex) => {
          const cell = xlsx.utils.encode_cell({ r: R, c: colIndex });
          if (ws[cell] && typeof ws[cell].v === 'number') {
            ws[cell].t = 'n';
            ws[cell].z = '#,##0.00';
          }
        });

        // Formatear columna de porcentaje (columna 19, índice 19)
        const porcentajeCell = xlsx.utils.encode_cell({ r: R, c: 19 });
        if (ws[porcentajeCell] && typeof ws[porcentajeCell].v === 'number') {
          ws[porcentajeCell].t = 'n';
          ws[porcentajeCell].z = '0.00%'; // Formato de porcentaje con 2 decimales
        }
      }

      // Agregar hoja al workbook
      xlsx.utils.book_append_sheet(wb, ws, 'INFO MORA (FINANCIAMIENTO)');

      // Descargar el archivo
      const fileName = `info-mora-financiamiento-${moment().format(
        'YYYY-MM-DD'
      )}.xlsx`;
      xlsx.writeFile(wb, fileName);
    },

    // Método auxiliar para calcular porcentaje de mora (retorna valor numérico sin símbolo)
    calcularPorcentajeMoraExcel(montoMora, capitalVencido) {
      if (!montoMora || !capitalVencido || capitalVencido === 0) return 0;
      return (parseFloat(montoMora) / parseFloat(capitalVencido)) * 100;
    },

    // Método específico para exportar Info Cte y No Cte
    generarExcelInfoCteYNoCte(todosLosDatos) {
      console.log(
        '📊 Excel Export Info Cte y No Cte - Registros:',
        todosLosDatos.length
      );

      if (!todosLosDatos || todosLosDatos.length === 0) {
        console.warn('No hay datos para exportar');
        return;
      }

      // Preparar datos para Excel
      const excelData = [];

      // Agregar título
      const titleRow = Array(20).fill(''); // Ajustar según cantidad de columnas
      titleRow[0] = 'INFO CTE Y NO CTE';
      excelData.push(titleRow);

      // Agregar fecha de consulta
      const consultaRow = Array(20).fill('');
      consultaRow[0] = `Fecha de consulta: ${this.fechaInicio || 'N/A'} - ${
        this.fechaFinal || 'N/A'
      }`;
      excelData.push(consultaRow);

      // Agregar fecha de generación
      const dateRow = Array(20).fill('');
      dateRow[0] = `Generado el: ${moment().format('DD/MM/YYYY HH:mm')}`;
      excelData.push(dateRow);

      // Agregar fila vacía
      excelData.push(Array(20).fill(''));

      // Headers dinámicos basados en los headers de la tabla actual
      const allHeaders = this.headers.map(header => header.text);
      excelData.push(allHeaders);

      // Procesar datos - usar los headers dinámicamente
      todosLosDatos.forEach((item) => {
        const row = [];

        this.headers.forEach(header => {
          const fieldValue = item[header.value];

          // Formatear valores según el tipo de campo
          if (typeof fieldValue === 'number') {
            row.push(parseFloat(fieldValue) || 0);
          } else if (header.value.includes('fecha') && fieldValue) {
            row.push(this.formatearFechaExcel(fieldValue));
          } else {
            row.push(fieldValue || '');
          }
        });

        excelData.push(row);
      });

      // Calcular totales para campos numéricos (excluir subtotales para evitar duplicación)
      const datosRegulares = todosLosDatos.filter(item => !item._esSubtotal);

      const totalRow = [];
      this.headers.forEach((header, index) => {
        if (index === 0) {
          totalRow.push('TOTAL GENERAL');
        } else if (index === 1) {
          totalRow.push(`${datosRegulares.length} registros`);
        } else if (datosRegulares[0] && typeof datosRegulares[0][header.value] === 'number') {
          // Calcular suma solo para registros regulares (sin subtotales)
          const total = datosRegulares.reduce((sum, item) => {
            return sum + (parseFloat(item[header.value]) || 0);
          }, 0);
          totalRow.push(total);
        } else {
          totalRow.push('');
        }
      });

      excelData.push(totalRow);

      // Crear workbook y worksheet
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();

      // Configurar anchos de columna dinámicamente
      const colWidths = this.headers.map((header, index) => {
        if (index === 0) return { wch: 10 }; // Legajo
        if (header.text.includes('Nombre') || header.text.includes('Razón')) return { wch: 35 };
        if (header.text.includes('Fideicomiso')) return { wch: 30 };
        if (header.text.includes('Operatoria')) return { wch: 25 };
        if (header.text.includes('Monto') || header.text.includes('Capital')) return { wch: 18 };
        if (header.text.includes('Fecha')) return { wch: 15 };
        return { wch: 15 }; // Ancho por defecto
      });

      ws['!cols'] = colWidths;

      // Formatear celdas numéricas
      const range = xlsx.utils.decode_range(ws['!ref']);
      for (let R = 5; R <= range.e.r; R++) {
        this.headers.forEach((header, C) => {
          if (datosRegulares[0] && typeof datosRegulares[0][header.value] === 'number') {
            const cell = xlsx.utils.encode_cell({ r: R, c: C });
            if (ws[cell] && typeof ws[cell].v === 'number') {
              ws[cell].t = 'n';
              ws[cell].z = '#,##0.00';
            }
          }
        });
      }

      // Agregar hoja al workbook
      xlsx.utils.book_append_sheet(wb, ws, 'INFO CTE Y NO CTE');

      // Descargar el archivo
      const fileName = `info-cte-no-cte-${moment().format('YYYY-MM-DD')}.xlsx`;
      xlsx.writeFile(wb, fileName);
    },
  },
};
